import { queryOptions, useQuery } from "@tanstack/react-query";
import { ApiError, createApi, type Me } from "@wilco/api";

export const api = createApi();

/**
 * Текущий пользователь. null: сессии нет (401), оболочка ведёт на вход.
 * Остальные ошибки летят дальше: «сервер недоступен» это не «выйдите».
 */
export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: async (): Promise<Me | null> => {
    const { data, error, response } = await api.GET("/api/v1/me");
    if (response.status === 401) return null;
    if (!data) throw new ApiError(response.status, error);
    return data;
  },
  staleTime: 5 * 60_000,
  retry: false,
});

/** Вход: сервер (Spring Security) уводит на Google и возвращает с сессией. */
export const LOGIN_URL = "/oauth2/authorization/google";

/**
 * Право из /me (AUT-08): меню и кнопки по нему только прячутся, проверяет
 * сервер на каждом вызове. Администратор может всё.
 */
export function useCan(): (permission: string) => boolean {
  const { data } = useQuery(meQuery);
  return (permission) => Boolean(data && (data.admin || data.permissions.includes(permission)));
}
